import { PROVIDERS, getProviderEnabled } from '@exodus/fiat-client'
import rampProvider, {
  ENABLED_ASSETS,
  getWidgetUrl as getRampWidgetUrl,
} from '@exodus/fiat-client/ramp'

const createProvider = ({ assets, config, enabled, kyc, ...options } = {}) =>
  rampProvider({
    ...options,
    apiKey: config.API_KEY,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    enabled: (args) => getProviderEnabled({ ...args, enabled, kyc, provider: PROVIDERS.ramp }),
    url: config.API_URL,
  })

export const getWidgetUrl = ({ assets, config, ...options } = {}) =>
  getRampWidgetUrl({
    ...options,
    apiKey: config.API_KEY,
    appName: config.APP_NAME,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    logoUrl: config.LOGO,
    url: config.URL,
  })

export default createProvider
